/**
 * Stores the language in a cookie.
 * @util
 *
 * @param language - The language code to store
 */
export function setCookie(name, value, options = {}) {
    if (typeof document === 'undefined') {
        return;
    }
    let cookie = `${name}=${value};`;
    if (options.expires) {
        cookie += ` expires=${options.expires.toUTCString()};`;
    }
    if (options.path) {
        cookie += ` path=${options.path};`;
    }
    if (options.sameSite) {
        cookie += ` SameSite=${options.sameSite};`;
    }
    if (options.secure) {
        cookie += ` Secure;`;
    }
    document.cookie = cookie;
}
//# sourceMappingURL=setCookie.js.map